"use client";
import React, { useEffect, useState } from "react";
import { Menu, Search, Bell } from "lucide-react";
import { useEmployee } from "../context/EmployeeContext";

const getGreeting = () => {
  const hour = new Date().getHours();
  if (hour < 12) return "Good Morning";
  if (hour < 17) return "Good Afternoon";
  return "Good Evening";
};

const getInitials = (first, last) => {
  const a = (first || "").trim().charAt(0);
  const b = (last || "").trim().charAt(0);
  const initials = `${a}${b}`.toUpperCase();
  return initials || "U";
};

export default function Header({ onMenuClick, sidebarCollapsed }) {
  const { getEmployeeById } = useEmployee();
  const [employee, setEmployee] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchEmployee = async () => {

    const user = JSON.parse(localStorage.getItem("user") || "{}");
    const userId = user?.id || null;

    //   const userId = localStorage.getItem("user_id"); // or from auth context
      if (!userId) return;

      const data = await getEmployeeById(userId);
      setEmployee(data);
      setLoading(false);
    };

    fetchEmployee();
  }, [getEmployeeById]);

  return (
    <header className="box-border flex justify-between items-center gap-4 px-9 py-4 m-0 bg-white border-b border-solid border-gray-200 shadow-sm max-sm:px-5 max-sm:py-4">
      <div className="box-border flex gap-5 items-center p-0 m-0 min-w-0 max-sm:gap-3">
        <button
          onClick={onMenuClick}
          className="box-border flex p-2 m-0 cursor-pointer items-center justify-center rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors duration-200 shrink-0"
          aria-label={sidebarCollapsed ? "Expand navigation menu" : "Collapse navigation menu"}
          title={sidebarCollapsed ? "Expand sidebar" : "Collapse sidebar"}
        >
          <Menu size={24} />
        </button>

        <div className="min-w-0 max-sm:hidden">
          <p className="text-base font-semibold text-gray-800 leading-tight truncate">
            {getGreeting()}{employee?.first_name ? `, ${employee.first_name}` : ""}
          </p>
          <p className="text-xs text-gray-500 leading-tight mt-0.5 truncate">
            {new Date().toLocaleDateString(undefined, {
              weekday: "long",
              year: "numeric",
              month: "long",
              day: "numeric",
            })}
          </p>
        </div>

        {/* <div className="box-border relative p-0 m-0 h-[38px] w-[388px] max-md:w-[250px] max-sm:w-[200px]">
          <div className="box-border p-0 m-0 rounded-2xl border-solid bg-gray-50 border border-gray-200 size-full" />
          <input
            type="search"
            placeholder="Search..."
            className="box-border absolute top-2/4 p-0 m-0 text-sm -translate-y-2/4 left-[45px] text-gray-700 bg-transparent border-none outline-none w-[calc(100%-60px)] placeholder-gray-500"
            aria-label="Search"
          />
          <Search
            size={16}
            className="absolute left-[17px] top-1/2 transform -translate-y-1/2 text-gray-400"
            aria-hidden="true"
          />
        </div> */}
      </div>

      <div className="box-border flex gap-3 sm:gap-4 items-center p-0 m-0 shrink-0">
        {/* <button
          className="box-border relative p-2 m-0 cursor-pointer rounded-lg hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-colors duration-200"
          aria-label="Notifications"
        >
          <Bell size={20} className="text-gray-600" />
          <span className="absolute -top-1 -right-1 w-3 h-3 bg-red-500 rounded-full" aria-hidden="true"></span>
        </button> */}

        <div className="hidden sm:block w-px h-9 bg-gray-200" aria-hidden="true" />

        <div className="box-border flex gap-3 items-center p-0 m-0 cursor-pointer group">
          <div
            className="flex items-center justify-center w-10 h-10 rounded-full text-white text-sm font-semibold ring-2 ring-gray-100 group-hover:ring-blue-200 transition-all duration-200 shrink-0"
            style={{ background: "linear-gradient(135deg, #2563eb, #d12465)" }}
            aria-hidden="true"
          >
            {getInitials(employee?.first_name, employee?.last_name)}
          </div>
          <div className="box-border flex flex-col p-0 m-0 max-sm:hidden">
            <div className="box-border p-0 m-0 text-sm font-semibold leading-tight text-gray-800">
              {employee?.first_name} {employee?.last_name}
            </div>
            <div className="box-border p-0 m-0 text-xs font-medium leading-tight text-gray-500 truncate max-w-[160px]">
              {employee?.designation && employee.designation !== "N/A"
                ? employee.designation
                : employee?.email}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
